import PublishEventModalContent from 'containers/publish-event-modal/publish-event-modal-steps/publish-event-modal-first-step/publish-event-modal-content/publishEventModalContent';

export default PublishEventModalContent;
